import { useMutation, useQueryClient } from "@tanstack/react-query";
import useIdentity from "@/features/ui/hooks/use-identity";
import { OrderHistoryOrderModificationFileRequest } from "@/features/my-order/features/order-history/features/final-copy/types";
import { orderHistoryApi } from "@/features/my-order/features/order-history/api";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const usePostOrderHistoryModificationFiles = (
  orderSheetSetId: string | null
) => {
  const queryClient = useQueryClient();
  const identity = useIdentity();
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const { error: showError, info, add } = useAppToasts();
  const { tSentence } = useI18nHelper();

  const { mutate: uploadFiles } = useMutation({
    mutationKey: ["order-history", "update-status", orderSheetSetId],
    mutationFn: (params: OrderHistoryOrderModificationFileRequest) =>
      orderHistoryApi.postModificationFiles(
        companyId!,
        orderSheetSetId ? +orderSheetSetId : 0,
        params
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "order-history",
          "detail",
          companyId,
          companyType,
          orderSheetSetId,
        ],
      });
      info(tSentence("order_history:file_upload_success"));
    },
    onError: (error) => {
      showError(error.message);
    },
  });

  return {
    uploadFiles,
  };
};

export default usePostOrderHistoryModificationFiles;
